import type { ErrorCodesByResponseStatus } from '../types/errors';

export const GLOBAL_API_ERROR_CODES = {
  CODE_400: {
    BAD_REQUEST: 'BAD_REQUEST',
    CONFIGURATION_ERROR: 'CONFIGURATION_ERROR',
    INVALID_HTTP_HEADER: 'INVALID_HTTP_HEADER',
    INVALID_QUERY_PARAM: 'INVALID_QUERY_PARAM',
    MALFORMED_PATH_PARAM: 'MALFORMED_PATH_PARAM',
    MALFORMED_QUERY_PARAM: 'MALFORMED_QUERY_PARAM',
    MISSING_HTTP_HEADER: 'MISSING_HTTP_HEADER',
    MISSING_QUERY_PARAM: 'MISSING_QUERY_PARAM',
  },
  CODE_401: {
    UNAUTHORISED: 'UNAUTHORISED',
  },
  CODE_403: {
    ACCESS_DENIED: 'ACCESS_DENIED',
  },
  CODE_404: {
    RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  },
  CODE_409: {
    CONFLICT: 'CONFLICT',
    IDEMPOTENCY_CONFLICT: 'IDEMPOTENCY_CONFLICT',
    RESOURCE_NOT_MODIFIABLE: 'RESOURCE_NOT_MODIFIABLE',
  },
  CODE_422: {
    VALIDATION_FAILURE: 'VALIDATION_FAILURE',
  },
  CODE_424: {
    FAILED_DEPENDENCY: 'FAILED_DEPENDENCY',
    RETRY_LIMIT_EXCEEDED: 'RETRY_LIMIT_EXCEEDED',
    UNAUTHORISED: 'UNAUTHORISED',
  },
  CODE_500: {
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  },
} as const satisfies ErrorCodesByResponseStatus;
